// extracted by mini-css-extract-plugin
export var bounce = "_lv-1";
export var generatingText = "_lv-6";
export var lightning = "_lv-4";
export var popup = "_lv-5";
export var progressBar = "_lv-7";
export var progressFill = "_lv-8";
export var progressShimmer = "_lv-9";
export var progressText = "_lv-a";
export var shimmer = "_lv-3";
export var uploadIcon = "_lv-0";
export var uploadingText = "_lv-2";